
/* eslint-disable no-unused-vars */
import EventCard from '../components/EventCard.vue'
import EventService from '../services/EventService'
import { EventItem } from '../types'
import { defineComponent, ref } from 'vue'
export default defineComponent({
  name: 'EventList',
  components: {
    EventCard
  },
  setup() {
    const events = ref([] as EventItem[])
    const eventService = EventService.getEvents()
      .then(response => {
        events.value = response.data
      })
      .catch(error => {
        console.log(error)
      })

    return {
      eventService,
      events
    }
  }
})
